import useSWR from 'swr';

export enum Impact {
  PARTIAL_OUTAGE = 'partial_outage',
  DEGRADED_PERFORMANCE = 'degraded_performance',
  FULL_OUTAGE = 'full_outage',
  OPERATIONAL = 'operational',
}

export enum Status {
  INVESTIGATING = 'investigating',
  IDENTIFIED = 'identified',
  MONITORING = 'monitoring',
  RESOLVED = 'resolved',
}

export enum MaintenanceStatus {
  MAINTENANCE_IN_PROGRESS = 'maintenance_in_progress',
  MAINTENANCE_SCHEDULED = 'maintenance_scheduled',
}

type Component = {
  id: string;
  name: string;
  group_name?: string;
  current_status: Impact;
};

type Incident = {
  id: string;
  name: string;
  status: Status;
  url: string;
  last_update_at: string;
  last_update_message: string;
  current_worst_impact: Impact;
  affected_components: Component[];
};

type Maintenance = {
  id: string;
  name: string;
  status: MaintenanceStatus;
  last_update_at: string;
  last_update_message: string;
  url: string;
  affected_components: Component[];
  started_at?: string;
  scheduled_end_at?: string;
  starts_at?: string;
  ends_at?: string;
};

type IncidentStatusResponse = {
  page_title: string;
  page_url: string;
  ongoing_incidents: Incident[];
  in_progress_maintenances: Maintenance[];
  scheduled_maintenances: Maintenance[];
};

const backend = import.meta.env?.VITE_BACKEND_URL || '';

export const STATUS_PAGE_URL = backend.startsWith('https://eu.api.smith.')
  ? 'https://eu.status.smith.langchain.com'
  : 'https://status.smith.langchain.com';

const INCIDENT_STATUS_API_URL = `${STATUS_PAGE_URL}/api/v1/summary`;

export const useIncidentStatus = () => {
  return useSWR(INCIDENT_STATUS_API_URL, async () => {
    if (!STATUS_PAGE_URL) {
      return null;
    }
    const response = await fetch(INCIDENT_STATUS_API_URL);
    try {
      return response.json() as Promise<IncidentStatusResponse>;
    } catch (error) {
      console.error(error);
      return null;
    }
  });
};
